export default {
  sites: [
    {
      siteName: 'Fast Company',
      siteDesc: 'Business + Innovation',
      siteLogo:
        'https://assets.fastcompany.com/image/upload/v1481129496/fc-square-48px.svg',
      options: [
        {
          name: 'Daily',
          value: '2'
        },
        {
          name: 'Weekly',
          value: '5'
        }
      ]
    },
    {
      siteName: 'Co.Design',
      siteDesc: 'Business + Design',
      siteLogo:
        'https://assets.fastcompany.com/image/upload/v1481129496/co-design-48px.svg',
      options: [
        {
          name: 'Daily',
          value: '6'
        },
        {
          name: 'Weekly',
          value: '11'
        }
      ]
    }
  ],
  daily: [
    {
      name: 'Leadership Daily',
      value: '4',
      desc:
        'Productivity tips and hacks, inspiring stories of success and failures, career advice, and a look inside the future of work.'
    },
    {
      name: 'News',
      value: '15',
      desc:
        'The most important, compelling and thought-provoking news in the worlds of business, tech, and innovation.'
    }
  ],
  weekly: [
    {
      name: 'Technology',
      value: '8',
      desc:
        "The world of gadgets, apps, services, and startups: what's new and what's next."
    },
    {
      name: 'Ideas',
      value: '7',
      desc: 'The big ideas that are changing the world.'
    },
    {
      name: 'Entertainment',
      value: '9',
      desc:
        'Creativity and innovation in entertainment, advertising, and pop culture.'
    },
    {
      name: 'Leadership Weekly',
      value: '10',
      desc:
        'Productivity tips and hacks, inspiring stories of success and failures, career advice, and a look inside the future of work. Once a week.'
    },
    {
      name: 'Moving The Needle',
      value: '19',
      desc:
        "Get the latest fashion news and analysis from Fast Company's Liz Segran."
    },
    {
      name: 'New Money',
      value: '24',
      desc:
        "Get the latest fintech news from Fast Company's Ainsley Harris every week."
    },
    {
      name: 'After These Messages',
      value: '40',
      desc:
        "Get the latest industry news, brand insight and analysis you need to know, all in one place from Co.Create's Jeff Beer."
    },
    {
      name: 'Key Change',
      value: '22',
      desc: 'Get the latest music news delivered to your inbox weekly.'
    },
    {
      name: 'Most Creative People',
      value: '12',
      desc:
        'Get weekly news and advice from the Most Creative People in Business.'
    },
    {
      name: 'Apple',
      value: '18',
      desc:
        "The latest Apple news from Fast Company's Mark Sullivan delivered to your inbox whenever there's news (but never more than once a week)."
    },
    {
      name: 'Future of Philanthropy',
      value: '21',
      desc:
        'For regular updates on the leaders, groups, tactics and ventures shaking up philanthropy.'
    },
    {
      name: 'Virtual Reality',
      value: '17',
      desc:
        "The latest VR news from Fast Company's Daniel Terdiman delivered to your inbox whenever there's news (but never more than once a week)."
    }
  ],
  promotions: [
    {
      name: 'Events',
      value: '25',
      desc:
        'Yes, I would like to be notified about events and exclusive offers from Fast Company.'
    },
    {
      name: 'Partner Offers',
      value: '31',
      desc:
        'Yes, I would like to receive occasional offers from commercial partners.'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/views/containers/pages/newsletters_page/newsletters_page_data.js